import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CePopoverOverlayComponent } from './ce-popover-overlay.component';
import { CePopoverTriggerForDirective } from './ce-popover-trigger.directive';

@Component({
    selector: 'ce-popover',
    imports: [CommonModule],
    templateUrl: './ce-popover.component.html',
    styleUrl: './ce-popover.component.scss'
})
export class CePopoverComponent {}

export const CePopoverImports = [CePopoverComponent, CePopoverOverlayComponent, CePopoverTriggerForDirective] as const;
